module.exports = __webpack_public_path__ + "static/media/foto-cabecera.75cabdaa.jpg";